<template>
  <div class="wrap">
    <article class="laboratory-info">
      <div class="wait-info">검사실 대기 현황
        <img src="@/assets/refresh.png" alt="refresh" @click="refreshLaboratoryInfo">
      </div>
      <div class="tip">검사실을 선택하시면 대기자를 확인할 수 있습니다.</div>
      <div class="table-wrap">
        <div class="thead">
          <div class="tr">
            <span class="th">
              방번호
            </span>
            <span class="th">
              검사실명
            </span>
            <span class="th">
              대기인원
            </span>
            <span class="th">
              완료인원
            </span>
          </div>
        </div>
        <img src="/static/Rolling.svg" alt="loading" v-if="isTreatLoading">
        <div class="tbody-wrap" v-else>
          <div class="tbody">
            <div class="tr" v-for="info in laboratoryDatas" :key="info.room_id" @click="showPersonList(info.room_id, info.room_nm)">
              <span class="td">
                {{info.room_id}}
              </span>
              <span class="td">
                {{info.room_nm}}
              </span>
              <span class="td">
                {{info.waiting_num}}
              </span>
              <span class="td">
                {{info.complete_num}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </article>
    <p class="right arrow">&#10093;</p>
    <article class="wait-person-info">
      <div class="wait-info">대기자 현황
        <p class="treat-info" v-if="treatInfo">{{treatInfo}}</p>
      </div>
      <div class="tip">
        대기자를 선택 하시면 검사 현황을 확인 할 수 있습니다.
        <span class="another-tip">검사중 선택시 완료 처리/대기중 선택시 호출</span>
      </div>
      <div class="table-wrap">
        <div class="thead">
          <div class="tr">
            <span class="th">NO</span>
            <span class="th">고객번호</span>
            <span class="th">성명</span>
            <span class="th">성별</span>
            <span class="th">연령</span>
            <span class="th">상태</span>
          </div>
        </div>
        <img src="/static/Rolling.svg" alt="loading" v-if="isWaitPersonLoading">
        <div class="tbody-wrap" v-else>
          <div class="tbody" v-if="waitPersonInfo">
            <div class="tr" v-for="info in waitPersonInfo" :key="info.index" @click="showWaitPatientInfo(info.chart_num)">
              <span class="td">{{info.index}}</span>
              <span class="td">{{info.chart_num}}</span>
              <span class="td">{{info.pat_nm}}</span>
              <span class="td">{{info.pat_gen}}</span>
              <span class="td">{{info.pat_age}}</span>
              <span class="td" @click="changeState(info.pat_nm, info.state, info.room_id, info.chart_num, treatInfo)">{{info.state}}</span>
            </div>
          </div>
        </div>
      </div>
    </article>
    <!-- <p class="down arrow">&#10093;</p> -->
    <patient-info :waitPatientInfo='waitPatientInfo' :patientState='patientState' :isLoading='isPatientInfoLoading' :errorMsg='errorMsg' @onChangeState='changeState' />
  </div>
</template>

<script>
import PatientInfo from './common/PatientInfo'
import qs from 'query-string'
export default {
  data () {
    return {
      laboratoryDatas: [],
      waitPersonInfo: [],
      waitPatientInfo: null,
      treatInfo: '',
      currentRoomNum: '',
      currentChartNum: '',
      patientState: null,
      isTreatLoading: true,
      isWaitPersonLoading: false,
      isPatientInfoLoading: false,
      errorMsg: ''
    }
  },
  components: {
    'patient-info': PatientInfo
  },
  created () {
    // 검사실 대기 현황 받아오기
    this.$http.get('/DID_API/whole_waiting_list.php')
      .then(result => {
        this.isTreatLoading = false
        this.laboratoryDatas = result.data.data
      })
      .catch(() => {
        alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
        this.isTreatLoading = false
      })
  },
  methods: {
    // 대기자 현황 보여주기
    showPersonList (no, desc) {
      this.treatInfo = desc
      this.currentRoomNum = no
      this.isWaitPersonLoading = true
      this.$http.get('/DID_API/whole_waiting_detail_list.php', {
        params: {
          'room_id': no
        }
      }
      )
        .then(result => {
          this.isWaitPersonLoading = false
          this.waitPersonInfo = result.data.data
        })
        .catch(() => {
          alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
          this.isWaitPersonLoading = false
        })
    },
    // 수진자 정보 보여주기
    showWaitPatientInfo (chartNum) {
      this.isPatientInfoLoading = true
      this.currentChartNum = chartNum
      this.refreshPatientInfo()
    },
    // 확인창 띄우기
    changeState (name, state, roomNum, patNum, treatInfo) {
      let question
      let code
      if (state === '미진행') {
        code = 0
        question = confirm(`${name} 님을 ${treatInfo}실로 이동 하시겠습니까?`)
      } else if (state === '대기중') {
        code = 1
        question = confirm(`${name} 님을 ${treatInfo}실로 호출 하시겠습니까?`)
      } else if (state === '검사중') {
        code = 2
        question = confirm(`${name} 님의 ${treatInfo}실 검사를 완료 하시겠습니까?`)
      } else {
        alert('검사가 완료된 환자 입니다.')
      }
      if (question && !code) {
        this.$http.post('/DID_API/jubsu.php', qs.stringify({
          room_id: roomNum,
          pat_id: patNum
        }), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
          .then(result => {
            if (result.data.r_code === 100) {
              this.refreshLaboratoryInfo()
              this.refreshWaitPersonList()
              this.refreshPatientInfo()
            } else {
              alert(result.data.r_msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else if (question) {
        this.$http.post('/DID_API/stat_update.php', qs.stringify({
          room_id: roomNum,
          pat_id: patNum,
          stat: code + 1
        }), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
          .then(result => {
            if (result.data.r_code === 100) {
              this.refreshLaboratoryInfo()
              this.refreshWaitPersonList()
              this.refreshPatientInfo()
            } else {
              alert(result.data.r_msg)
            }
          })
          .catch(() => {
            alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
          })
      }
    },
    // 검사실 대기 현황 새로고침
    refreshLaboratoryInfo () {
      this.isTreatLoading = true
      this.$http.get('/DID_API/whole_waiting_list.php')
        .then(result => {
          this.isTreatLoading = false
          this.laboratoryDatas = result.data.data
        })
        .catch(() => {
          alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
          this.isTreatLoading = false
        })
    },
    refreshPatientInfo () {
      this.$http.get('/DID_API/patient_detail.php', {
        params: {
          chart_num: this.currentChartNum
        }
      })
        .then(result => {
          if (result.data.r_code === 200) {
            this.errorMsg = result.data.r_msg
          } else {
            this.waitPatientInfo = result.data
            this.patientState = result.data.data
          }
          this.isPatientInfoLoading = false
        })
        .catch(() => {
          alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
          this.isPatientInfoLoading = false
        })
    },
    refreshWaitPersonList () {
      this.isWaitPersonLoading = true
      this.$http.get('/DID_API/whole_waiting_detail_list.php', {
        params: {
          'room_id': this.currentRoomNum
        }
      }
      )
        .then(result => {
          this.isWaitPersonLoading = false
          this.waitPersonInfo = result.data.data
        })
        .catch(() => {
          alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
          this.isWaitPersonLoading = false
        })
    }
  }
}
</script>

<style scoped lang='scss'>
@import './common/table';
.tbody-wrap {
  background-color: white;
}

.thead {
  .tr {
    height: 5.5vh;
    line-height: 5.5vh;
    position: absolute;
    top: 0px;
  }
  .th {
    height: 100%;
  }
}
.tbody {
  .td {
    padding: 10px 0px;
    text-align: center;
    &:last-child {
      margin-right: 0px;
    }
  }
}
img[alt='loading'] {
  display: block;
  position: absolute;
  width: 80px;
  height: 80px;
  left: 50%;
  margin-left: -40px;
  top: 50%;
  margin-top: -40px;
}
.laboratory-info {
  position: relative;
  float: left;
  width: 30vw;
  height: 95vh;
  margin: 2vh 2vw 0px 1.5vw;
  border: 1px solid #aaaaaa;
  background-color: white;
  .table-wrap {
    padding-top: 5.5vh;
    position: relative;
    overflow: hidden;
    height: 82vh;
    .tbody-wrap {
      height: 77vh;
    }
  }
  img[alt='refresh'] {
    float: right;
    display: block;
    margin: 0.3vh 0.7vw 0px 0px;
    width: 3vw;
  }
  .th {
    &:first-child {
      width: 5vw;
    }

    &:nth-child(2) {
      width: 9.8vw;
    }
    &:nth-child(3),
    &:nth-child(4) {
      width: 6.8vw;
    }
    &:nth-child(4) {
      border-right: none;
    }
  }
  .tbody .tr .td {
    &:first-child {
      width: 5vw;
    }
    &:nth-child(2) {
      width: 9.8vw;
    }
    &:nth-child(3),
    &:nth-child(4) {
      width: 6.8vw;
    }
    .eightletter {
      font-size: 12px;
    }
  }
  .wait-info {
    width: 100%;
    height: 7vh;
    background-color: #6982b3;
    padding-left: 20px;
    font-size: 28px;
    color: white;
    line-height: 7vh;
  }
  .tip {
    width: 100%;
    height: 5vh;
    line-height: 5vh;
    padding-left: 20px;
    background-color: #8a8ab5;
    color: white;
    font-size: 14px;
  }
}

.wait-person-info {
  position: relative;
  width: 52vw;
  background-color: white;
  margin: 2vh 0px 1vh 1vw;
  height: 55.5vh;
  float: left;
  border: 1px solid #aaaaaa;
  overflow: auto;
  .table-wrap {
    padding-top: 5.5vh;
    position: relative;
    // -ms-overflow-style: none; // IE 10+
    overflow: hidden;
    height: 43vh;
    .tbody-wrap {
      height: 38vh;
    }
  }
  .th {
    &:first-child {
      width: 5vw;
    }

    &:nth-child(2) {
      width: 13.8vw;
    }

    &:nth-child(3) {
      width: 9vw;
    }

    &:nth-child(4),
    &:nth-child(5) {
      width: 6.5vw;
    }
    &:nth-child(6) {
      width: 8vw;
      border-right: none;
    }
  }
  .tbody .tr .td {
    &:first-child {
      width: 5vw;
    }
    &:nth-child(2) {
      width: 13.8vw;
    }

    &:nth-child(3) {
      width: 9vw;
    }

    &:nth-child(4),
    &:nth-child(5) {
      width: 6.5vw;
    }
    &:nth-child(6) {
      width: 8vw;
    }
  }
  .wait-info {
    width: 100%;
    height: 7vh;
    background-color: #4fa0a3;
    padding-left: 20px;
    font-size: 28px;
    color: white;
    line-height: 7vh;
    .treat-info {
      float: right;
      margin-right: 20px;
    }
  }
  .tip {
    width: 100%;
    height: 5vh;
    line-height: 5vh;
    padding-left: 20px;
    background-color: #7eaba4;
    color: white;
    font-size: 14px;
    .another-tip {
      float: right;
      margin-right: 10px;
    }
  }
}
.arrow {
  display: inline-block;
  position: absolute;

  font-size: 70px;
  color: #a7cc57;
}
.right {
  top: 25%;
  left: 43.8vw;
}
// .down {
//   transform: rotateZ(90deg);
//   top: 53.5%;
//   right: 26vw;
//   z-index: 999999999;
// }
// @media screen and (min-width: 1300px) {
//   .down {
//     top: 55vh;
//   }
// }

@media screen and (min-width: 1500px) {
  .laboratory-info {
    .tbody .tr .td:nth-child(4) {
      width: 5.4vw !important;
      padding-left: 1vw;
    }
    img[alt='refresh'] {
      width: 2.2vw;
    }
  }
}

@media screen and (max-width: 1231px) {
  .laboratory-info,
  .wait-person-info {
    .wait-info {
      font-size: 24px;
    }
    .tip {
      font-size: 10px;
    }
    .thead .tr {
      font-size: 17px;
    }
    .tbody .tr .td {
      padding: 5px;
      margin-right: 0px;
      &:nth-child(2) {
        font-size: 16px;
      }
    }
  }
  .laboratory-info .thead .tr {
    font-size: 15px;
  }
  // .sixletter {
  //   font-size: 13px;
  //   position: relative;
  //   bottom: 3px;
  // }
  // .eightletter {
  //   font-size: 9px;
  //   bottom: 3px;
  // }
}
// @media screen and (min-width: 1600px) {
//   .laboratory-info
// }
@media screen and (max-height: 610px) {
  .laboratory-info,
  .wait-person-info {
    .wait-info {
      font-size: 22px;
    }
    .tip {
      font-size: 10px;
    }
    .thead .tr {
      font-size: 17px;
    }
    .tbody .tr .td {
      padding: 5px;
      // &:nth-child(2) {
      //   font-size: 10px;
      // }
    }
  }
  .laboratory-info .thead .tr {
    font-size: 15px;
  }
  .patient-info-wrap .info > span {
    padding-top: 8px;
  }
  .down {
    top: 51.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TreatSearch.vue